import { j as jsxRuntimeExports } from "../../../jsx-runtime-9d42c573.js";
import { useCallback } from "react";
const ImageComp = ({
  url,
  urlSet,
  className = "",
  width,
  height,
  style = {},
  alt,
  onLoad,
  onError,
  ...rest
}) => {
  const handleImgLoad = useCallback(
    (event) => {
      onLoad == null ? void 0 : onLoad({ ...event, url });
    },
    [onLoad, url]
  );
  const handleImgLoadError = useCallback(
    (event) => {
      onError == null ? void 0 : onError({ ...event, url });
    },
    [onError, url]
  );
  const _urlSet = url === "" ? "" : `${urlSet[0]} 1x, ${urlSet[1]} 2x, ${urlSet[2]} 3x`;
  if (!url)
    return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "img",
    {
      src: url,
      srcSet: _urlSet,
      className,
      style: {
        ...style
      },
      width,
      height,
      alt,
      onLoad: handleImgLoad,
      onError: handleImgLoadError,
      ...rest
    }
  );
};
export {
  ImageComp as default
};
//# sourceMappingURL=imageComp.js.map
